import axios from "axios";
import { configUrl } from "config";

const getPaymentSummary = async (userId, programId) => {
    try {
        const response = await axios.get(
            `${configUrl.AssessmentServer}/api/ProviderPayment/slab-status/${userId}/${programId}`,
        );

        return response?.data;
    } catch (error) {
        console.error("Get Payment Summary Error:", error?.response || error);
        return null;
    }
};

export default getPaymentSummary;
